import React from 'react';

export default {
    key: 'salesBackUpdate-action',
    build(stub) {
        class SalesBackUpdateAction extends React.Component {
            constructor(props) {
                super(props);
                this.state = {};
            }

            onClick = e => {
                e.stopPropagation();
                const { field, sceenKey, module, model } = this.props;
                const { formatter: { args: { listKey, filterKey } } } = field;
                stub.ui.helper.addTabPage({
                    component: stub.module[module][sceenKey].salesBackComponentDetail,
                    listKey: listKey,
                    filterKey: filterKey,
                    title: '回款详情',
                    model: model
                })
            };

            render() {
                const { field: { label } } = this.props;
                return(<a href="javascript:" onClick={this.onClick}>{stub.filter.transform(label)}</a>)
            }
        }

        return SalesBackUpdateAction;
    }
}
